import React from 'react';
import classNames from 'classnames';

import { StyledHr } from './Hr.style';

const Hr = ({ rootClassName, className }: HrProps) => {
  const classes = classNames(rootClassName || 'styled-hr', className);
  return (
    <>
      <StyledHr className={classes} />
    </>
  );
};

export interface HrProps {
  rootClassName?: string;
  className?: string;
}

export default Hr;
